/* eslint-disable */
import React, { useState, useEffect } from "react";
import axiosClient from "../../../utils/axiosClient";
import {
  urlHorariosAtendimentoUsuario,
  urlHorariosDisponiveisAgendamentoUsuario,
  urlServicosAgendamentoUsuario,
  urlAdicionar,
} from "../../../utils/constants";
import MenuSide from "../../../components/usuarios/MenuSide";
import {
  IonCard,
  IonItem,
  IonLabel,
  IonContent,
  IonPage,
  IonBadge,
  IonButton,
  IonTextarea,
  IonDatetime,
  IonToast,
  IonAlert,
  IonLoading,
} from "@ionic/react";
import moment from "moment";
import "./style.css";
import { useNavigate } from "react-router-dom";
import HeaderApp from "../../../components/global/HeaderItem";
import ModalServicos from "./ModalServicos";
// Usando input date nativo em vez do calendário custom

const consultaHorariosAtendimento = async (dataAgendamento) => {
  try {
    const response = await axiosClient.post(urlHorariosAtendimentoUsuario, {
      data_agendamento: dataAgendamento,
    });
    return response.data;
  } catch (error) {
    return [];
  }
};

const consultaHorariosDisponiveis = async (dataAgendamento) => {
  try {
    const response = await axiosClient.post(
      urlHorariosDisponiveisAgendamentoUsuario,
      {
        data_selecionada: dataAgendamento,
      }
    );
    return response.data;
  } catch (error) {
    return [];
  }
};

const consultaServicos = async () => {
  try {
    const response = await axiosClient.post(urlServicosAgendamentoUsuario, {});
    return response.data;
  } catch (error) {
    return [];
  }
};

const getDayOfWeek = (dateString) => {
  const days = [
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
    "Domingo",
  ];
  const date = new Date(dateString);
  const dayIndex = date.getDay();
  return days[dayIndex];
};

const servicoBloqueadoNoPeriodo = (servicoId, data) => {
  const servicosComPe = [3, 7, 85, 90];
  const dataSelecionada = moment(data, "YYYY-MM-DD", true);

  return (
    servicosComPe.includes(Number(servicoId)) &&
    dataSelecionada.isValid() &&
    dataSelecionada.isBetween(
      "2026-12-18",
      "2026-12-23",
      "day",
      "[]"
    )
  );
};

const getDatesOfMonth = (year, month) => {
  const startDate = new Date(year, month - 1, 1);
  const endDate = new Date(year, month, 0);
  const datesArray = [];

  for (
    let date = startDate;
    date <= endDate;
    date.setDate(date.getDate() + 1)
  ) {
    const currentDate = new Date(date);
    if (currentDate.getMonth() === month - 1) {
      const data = currentDate.toISOString().split("T")[0];
      const dia = currentDate.getDate();
      const mes = currentDate.getMonth() + 1;
      const ano = currentDate.getFullYear();

      datesArray.push({ data, dia, mes, ano });
    }
  }

  return datesArray;
};

function groupDatesByWeekday(dates) {
  const weekdays = ["DOM.", "SEG.", "TER.", "QUA.", "QUI.", "SEX.", "SÁB."];
  const groupedDates = {
    "DOM.": [],
    "SEG.": [],
    "TER.": [],
    "QUA.": [],
    "QUI.": [],
    "SEX.": [],
    "SÁB.": [],
  };

  dates.forEach((date) => {
    const weekdayIndex = new Date(date.data).getDay();
    const weekday = weekdays[weekdayIndex];
    groupedDates[weekday].push(date);
  });

  return groupedDates;
}

const categorizeHorario = (horario) => {
  const [hour] = horario.split(":").map(Number);

  if (hour >= 5 && hour < 12) {
    return {
      categoria: "Manhã",
      icon: <i className="ri-sun-foggy-fill" style={{ color: " #FDEC75" }}></i>,
    };
  } else if (hour >= 13 && hour < 18) {
    return {
      categoria: "Tarde",
      icon: <i className="ri-sun-fill" style={{ color: "#FF8800" }}></i>,
    };
  } else {
    return {
      categoria: "Noite",
      icon: <i className="ri-moon-fill" style={{ color: "#153C4B" }}></i>,
    };
  }
};

export default function AgendarUsuario() {
  const dataAtual = moment().format("YYYY-MM-DD");

  const [modalServicos, setModalServicos] = useState(false);
  const [nomeServico, setNomeServico] = useState("");
  const [diaDisponivel, setDiaDisponivel] = useState(true);
  const [listaHorariosNecessarios, setListaHorariosNecessarios] = useState([]);
  const [qntHorasAgendamento, setQntHorasAgendamento] = useState(0);
  const [loading, setLoading] = useState(false);

  const [dataAgendamento, setDataAgendamento] = useState(dataAtual);
  const [dataAgendamentoExibicao, setDataAgendamentoExibicao] = useState(
    new Date()
  );
  const [horaAgendamento, setHoraAgendamento] = useState("");
  const [obsAgendamento, setObsAgendamento] = useState("");
  const [servicoAgendamento, setServicoAgendamento] = useState("");

  const [corMensagemDiaSelecionado, setCorMensagemDiaSelecionado] =
    useState("secondary-light");
  const [mensagemDiaSelecionado, setMensagemDiaSelecionado] = useState("");
  const [horariosDisponiveis, setHorariosDisponiveis] = useState([]);
  const [servicos, setServicos] = useState([]);
  const navigate = useNavigate();

  const [mesAtual, setMesAtual] = useState(moment().format("MM"));
  const [anoAtual, setAnoAtual] = useState(moment().format("YYYY"));
  const [dias, setDias] = useState(getDatesOfMonth(anoAtual, mesAtual));
  const [diasSemana, setDiasSemana] = useState(groupDatesByWeekday(dias));

  const [colorToast, setColorToast] = useState("");
  const [iconToast, setIconToast] = useState("");
  const [mensagemToast, setMensagemToast] = useState("");
  const [tempoToast, setTempoToast] = useState("");
  const [textoToast, setTextoToast] = useState("");
  const [statusToast, setStatusToast] = useState(false);

  const [statusAlert1, setAlert1] = useState(false);
  const [statusAlert2, setAlert2] = useState(false);
  const [statusAlert3, setAlert3] = useState(false);

  const agendamentoBloqueado = servicoBloqueadoNoPeriodo(
    servicoAgendamento,
    dataAgendamento
  );

  useEffect(() => {
    setMesAtual(moment().format("MM"));
    setAnoAtual(moment().format("YYYY"));
    setDias(getDatesOfMonth(anoAtual, mesAtual));
    setDiasSemana(groupDatesByWeekday(dias));
  }, []);

  const agendarHorario = async () => {
    if (agendamentoBloqueado) return;

    try {
      setLoading(true);

      const response = await axiosClient.post(
        urlAdicionar("usuarios", "agendar"),
        {
          data_agendamento: moment(dataAgendamento).format("YYYY-MM-DD"),
          hora_agendamento: horaAgendamento,
          servico_id: Number(servicoAgendamento),
          obs: obsAgendamento,
        }
      );
      
      if (response.data.status === "agendamento_efetuado") {
        const id = response.data.id;
        setColorToast("success");
        setIconToast("alert-outline");
        setMensagemToast("Agendamento efetuado com sucesso.");
        setTempoToast(60000);
        setTextoToast("Ok");
        setStatusToast(true);

        setTimeout(() => {
          navigate({ pathname: `/usuarios/confirmacao?id=${id}` });
        }, 1000);
      } else if (response.data.status === "horario_indisponivel") {
        setColorToast("danger");
        setIconToast("alert-outline");
        setMensagemToast("Ops, alguém acabou de agendar nesse horário.");
        setTempoToast(60000);
        setTextoToast("Ok");
        setStatusToast(true);
      } else if (response.data.status === "campo_vazio") {
        setColorToast("warning");
        setIconToast("alert-outline");
        setMensagemToast(
          `Ops, o campo ${response.data.campo} precisa ser preenchido!`
        );
        setTempoToast(60000);
        setTextoToast("Ok");
        setStatusToast(true);
      } else if (response.data.status === "nao_logado") {
        setAlert1(true);
      } else if (response.data.status === "empresa_nao_selecionada") {
        setColorToast("danger");
        setIconToast("alert-outline");
        setMensagemToast("Nenhuma empresa selecionada.");
        setTempoToast(60000);
        setTextoToast("Ok");
        setStatusToast(true);
      } else if (response.data.status === "nao_atendemos_nesse_dia") {
        setColorToast("danger");
        setIconToast("alert-outline");
        setMensagemToast("Ops, nós não atendemos no dia selecionado.");
        setTempoToast(60000);
        setTextoToast("Ok");
        setStatusToast(true);
      } else if (response.data.status === "fora_horario") {
        setColorToast("danger");
        setIconToast("alert-outline");
        setMensagemToast("Ops, nós não atendemos no horário selecionado.");
        setTempoToast(60000);
        setTextoToast("Ok");
        setStatusToast(true);
      } else if (response.data.status === "limite_atingido") {
        setAlert2(true);
      }
    } catch (error) {
      console.error("Erro ao agendar horário:", error);

      setColorToast("danger");
      setIconToast("alert-outline");
      setMensagemToast(
        error.response?.data?.message ||
          "Ocorreu um erro inesperado. Tente novamente."
      );
      setTempoToast(60000);
      setTextoToast("Ok");
      setStatusToast(true);
    } finally {
      setTimeout(() => setLoading(false), 300);
    }
  };

  useEffect(() => {
    const verificarServicos = async () => {
      const resultado = await consultaServicos();
      setServicos(resultado);
    };
    verificarServicos();
  }, [diasSemana]);

  useEffect(() => {
    const verificarHorarios = async () => {
      const resultadoHorario = await consultaHorariosAtendimento(
        dataAgendamento
      );
      setMensagemDiaSelecionado(resultadoHorario.mensagem);
      if (resultadoHorario.status === "disponivel") {
        setDiaDisponivel(true);
        setCorMensagemDiaSelecionado("success");
      } else {
        setDiaDisponivel(false);
        setCorMensagemDiaSelecionado("danger");
      }
    };
    verificarHorarios();

    const verificarHorariosDisponiveis = async () => {
      const resultadoHorario = await consultaHorariosDisponiveis(
        dataAgendamento
      );
      setHorariosDisponiveis(
        Array.isArray(resultadoHorario) ? resultadoHorario : []
      );
    };
    verificarHorariosDisponiveis();
  }, [dataAgendamento]);

  const servicoSelecionado = (servico) => {
    if (servico) {
      setServicoAgendamento(servico.id);
      setNomeServico(servico.nome);
    }
  };

  const horariosPorCategoria = horariosDisponiveis.reduce((acc, horario) => {
    const { categoria, icon } = categorizeHorario(horario);
    if (!acc[categoria]) acc[categoria] = { horarios: [], icon };
    acc[categoria].horarios.push(horario);
    return acc;
  }, {});

  const verificarDisponibilidadeHorario = (horarioSelecionado) => {
    if (!servicoAgendamento || !horarioSelecionado) return;

    const servicoSelecionado = servicos.find(
      (s) => s.id === servicoAgendamento
    );
    if (!servicoSelecionado) return;

    const duracaoServico = servicoSelecionado.tempo;
    let qtdIntervalosNecessarios = duracaoServico / 60; // Definição correta

    const horarioInicial = moment(horarioSelecionado, "HH:mm");

    let horariosNecessarios = [];

    for (let i = 0; i < qtdIntervalosNecessarios; i++) {
      const proximoHorario = horarioInicial.clone().add(i * 60, "minutes");
      horariosNecessarios.push(proximoHorario.format("HH:mm"));
    }

    const horariosSuficientes = horariosNecessarios.every((h) =>
      horariosDisponiveis.includes(h)
    );

    if (!horariosSuficientes) {
      setQntHorasAgendamento(qtdIntervalosNecessarios);
      setAlert3(true);
      setListaHorariosNecessarios([]);
      return false;
    }

    setListaHorariosNecessarios(horariosNecessarios);
    return true;
  };

  const horarioEstaSelecionado = (horario) => {
    return (
      Array.isArray(listaHorariosNecessarios) &&
      listaHorariosNecessarios.includes(horario)
    );
  };

  const handleSelecionarHorario = (horario) => {
    if (verificarDisponibilidadeHorario(horario)) {
      setHoraAgendamento(horario);
    }
  };

  const dateAtual = new Date();
  const handleDateChange = (newDate) => {
    const dateObj = newDate ? new Date(newDate) : new Date();
    setDataAgendamentoExibicao(dateObj);
    const formattedDate = moment(newDate).format("YYYY-MM-DD");
    setDataAgendamento(formattedDate);
  };

  const [date, setDate] = useState(null);
  const minDate = new Date();

  return (
    <IonPage id="main-content">
      <IonContent>
        <HeaderApp />
        <div className="ion-margin">
          <IonLabel position="stacked">Data do Agendamento</IonLabel>
          <div>
            <IonDatetime
              displayFormat="DD/MM/YYYY"
              value={dataAgendamento}
              presentation='date'
              min={moment(minDate).format("YYYY-MM-DD")}
              onIonChange={(e) => handleDateChange(e.detail.value)}
            />
          </div>

          <IonCard color={corMensagemDiaSelecionado}>
            <div style={{ margin: 12 }}>
              {moment(dataAgendamento).format("DD/MM/YYYY")} -{" "}
              {getDayOfWeek(dataAgendamento)} : {mensagemDiaSelecionado}
            </div>
          </IonCard>

          <IonItem button onClick={() => setModalServicos(true)}>
            <IonLabel>
              {nomeServico ? (
                <>
                  <IonBadge color="secondary-light" slot="end">
                    {nomeServico}
                  </IonBadge>
                  <h4>Clique para alterar o serviço</h4>
                </>
              ) : (
                <>
                  <h4>
                    <IonBadge color="secondary-light" slot="end">
                      Selecione um serviço
                    </IonBadge>
                  </h4>
                </>
              )}
            </IonLabel>
          </IonItem>

          <ModalServicos
            modalServicos={modalServicos}
            setModalServicos={setModalServicos}
            onServicoSelecionado={servicoSelecionado}
          />

          <div className="row">&nbsp;</div>
          {agendamentoBloqueado && (
            <IonCard color="warning">
              <div style={{ margin: 12 }}>
                Não é possível agendar serviços que contenham pé entre
                18/12/2026 e 23/12/2026.
              </div>
            </IonCard>
          )}
          {servicoAgendamento !== "" && diaDisponivel ? (
            <div>
              <div className="ion-text-center" style={{ marginTop: "7px" }}>
                <IonLabel position="stacked">Defina o horário</IonLabel>
              </div>
              <div className="ion-margin-horizontal">
                {Object.entries(horariosPorCategoria).map(
                  ([categoria, { horarios, icon }]) => (
                    <div key={categoria}>
                      <h3>
                        {icon} {categoria}
                      </h3>
                      <div className="row">
                        {horarios.map((horario, index) => (
                          <div
                            className="col-4"
                            key={index}
                            style={{ marginBottom: "5px" }}
                          >
                            <div
                              key={index}
                              onClick={() => handleSelecionarHorario(horario)}
                              style={{
                                padding: "10px 20px",
                                borderRadius: "12px",
                                textAlign: "center",
                                cursor: "pointer",
                                fontSize: "13px",

                                border: horarioEstaSelecionado(horario)
                                  ? "solid 2px #141458"
                                  : "2px solid #ccc",
                                color: horarioEstaSelecionado(horario)
                                  ? "#004085"
                                  : "#333",
                                boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                transition: "0.3s",
                              }}
                            >
                              {horarioEstaSelecionado(horario) && (
                                <i className="ri-check-line"></i>
                              )}
                              {horario}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          ) : (
            <span></span>
          )}
          <br />
          <IonLabel position="stacked">Alguma observação?</IonLabel>
          <IonItem>
            <IonTextarea
              className="obs"
              placeholder="Informe sua observação"
              onIonChange={(e) => setObsAgendamento(e.detail.value)}
              value={obsAgendamento}
            ></IonTextarea>
          </IonItem>
          <br />
          {!loading && (
            <IonButton
              disabled={
                !servicoAgendamento || !horaAgendamento || agendamentoBloqueado
              }
              expand="full"
              color="secondary-light"
              onClick={agendarHorario}
            >
              Agendar &nbsp; <i className="ri-calendar-line icone19px"></i>
            </IonButton>
          )}

          {loading && (
            <IonButton disabled={true} expand="full" color="secondary-light">
              Aguarde &nbsp; <i className="ri-loader-3-line icone19px spin"></i>
            </IonButton>
          )}
          <br />
        </div>

        <IonToast
          isOpen={statusToast}
          color={colorToast}
          icon={iconToast}
          message={mensagemToast}
          onDidDismiss={() => setStatusToast(false)}
          duration={tempoToast}
          buttons={[
            {
              text: textoToast,
              role: "info",
              handler: () => {
                return;
              },
            },
          ]}
        ></IonToast>

        <IonAlert
          isOpen={statusAlert1}
          header="Atenção"
          message="Você precisa estar logado na sua conta para fazer um agendamento!"
          buttons={[
            {
              text: "Entrar",
              role: "cancel",
              handler: () => {
                navigate({ pathname: "/entrar" });
              },
            },
          ]}
          onDidDismiss={() => setAlert1(false)}
        ></IonAlert>

        <IonAlert
          isOpen={statusAlert2}
          header="Atenção"
          message="Seu limite de agendamentos mensais do plano grátis foi atingido, contrate o plano profissional para utilizar sem limitações!"
          buttons={[
            {
              text: "Contratar",
              role: "confirm",
              handler: () => {
                navigate({ pathname: "/empresas/inicio" });
              },
            },
          ]}
          onDidDismiss={() => setAlert2(false)}
        ></IonAlert>

        <IonAlert
          isOpen={statusAlert3}
          header="Atenção"
          message={`O serviço selecionado requer ${qntHorasAgendamento} horas consecutivas. Por favor, escolha um horário com disponibilidade de ${qntHorasAgendamento} horas seguidas.`}
          buttons={[
            {
              text: "Ok",
              role: "confirm",
              handler: () => {
                setHoraAgendamento(null);
                setListaHorariosNecessarios([]);
              },
            },
          ]}
          onDidDismiss={() => setAlert3(false)}
        ></IonAlert>
      </IonContent>
      <MenuSide />
    </IonPage>
  );
}
